import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import type { LevumiSubject } from '../../enums/CampusLevumiEnums.js';

/**
 * Manual level override for Chancenkurve
 * Allows teachers to force a specific level for a student's next test
 * Override is cleared after student completes a test at the forced level
 */
@Entity()
export class ChancenkurveLevelOverride extends MongoEntity {
  static override _class = 'ChancenkurveLevelOverride';
  static override _collectionName = 'chancenkurve-level-overrides';

  @Field(() => String)
  userID: Maybe<string>;

  @Field(() => String)
  subject: Maybe<LevumiSubject>;

  @Field(() => String)
  forcedLevel: Maybe<string>;

  @Field(() => String)
  setBy: Maybe<string>;

  @Field(() => Date)
  setAt: Maybe<Date>;

  @Field(() => String)
  reason: Maybe<string>;
}
